
import store_consultation from '@/store/mods/consultations/consultations'
import store_config from '@/store/mods/parametres/config'
import ChoixFicheConsultation from '@/views/consultations/en-cours/choix-fiche-consultation'
import FeuilleSurveillanceConstantes from '@/components/feuille-surveillance-constantes'
import { consultation_issues, clinical_evolutions, issueLabel, evolutionLabel } from '@/utils/consultation-issues'
import calendar from '@/utils/clinic-calendar'
import { dateComplement, fuseauComplement } from '@/utils/complement-date'
import RendezVousMedecin from '../rendez-vous-medecin'

export default {
    name: 'consultations-medecin',
    components: { ChoixFicheConsultation, RendezVousMedecin, FeuilleSurveillanceConstantes },
    props: {
        mode_sage_femme: { type: Boolean, default: false },
        tableau_api: { type: Object, default: () => store_consultation },
        scope_initial: { type: String, default: 'waiting' },
        period: { type: String, default: '' },
        month: { type: String, default: '' },
        mode_detail: { type: Boolean, default: false },
        mode_infirmier: { type: Boolean, default: false },
        mode_constantes: { type: Boolean, default: false }
    },
    data() {
        const filtres = {}
        ;['waiting', 'ongoing', 'closed', 'all', 'constantes_pending', 'constantes_done', 'started_today', 'started_month'].forEach(scope => {
            filtres[scope] = { recherche: '', type_id: '', medecin_id: '', page: 1, issue_consultation: '', evolution_clinique: '' }
        })
        // Onglet Rendez-vous : infirmier seulement (le médecin a sa carte « Mes rendez-vous » sous celle-ci)
        const onglets = this.mode_constantes ? [{ id: 'constantes_pending', nom: 'À prendre' }, { id: 'constantes_done', nom: 'Prises' }] : [
            { id: 'waiting', nom: 'En attente' },
            { id: 'ongoing', nom: 'En cours' },
            { id: 'closed', nom: 'Clôturées' },
            { id: 'all', nom: 'Toutes les consultations' }
        ].filter(onglet => !this.mode_sage_femme || onglet.id !== 'all').concat(this.mode_infirmier && !this.mode_detail ? [{ id: 'appointments', nom: 'Rendez-vous' }] : [])
            .concat(this.mode_infirmier && this.mode_detail ? [{ id: 'started_today', nom: 'Aujourd’hui' }, { id: 'started_month', nom: 'Ce mois' }] : [])
        return {
            feuille_consultation_id: null, feuille_visible: false,
            onglet_actif: this.mode_constantes ? 'constantes_pending' : onglets.some(onglet => onglet.id === this.scope_initial) ? this.scope_initial : 'waiting',
            issues: consultation_issues, evolutions: clinical_evolutions,
            onglets,
            filtres, liste_consultations: [], liste_types: [], liste_medecins: [],
            is_loading: true, rafraichissement_discret: false, is_error: false, erreur_medecins: false,
            prise_reference_en_cours: null, erreur_reference: '', erreur_acces_sf: '',
            total: 0, total_pages: 1, page_courante: 1, onglet_charge: '',
            compteurs: null, fuseau_horaire: '', erreur_service: '',
            sequence: 0, requetes_en_cours: 0, refresh_timer: null, recherche_timer: null,
            maintenant: Date.now(), est_detruit: false,
            // Badge de l'onglet Rendez-vous de l'infirmier : rendez-vous planifiés aujourd'hui (tous les médecins)
            rdv_actifs: null, rdv_sequence: 0
        }
    },
    computed: {
        auteur_demarrage() {
            const user = this.$store.getters.authInfo || {}
            return { id: Number(user.id) || 0, user: user.name, titre: user.titre }
        },
        chargement_visible() { return this.is_loading && !this.rafraichissement_discret },
        prefixe() { return this.mode_sage_femme ? (this.mode_detail ? 'sf-detail' : 'sf') : this.mode_constantes ? 'inf-constantes' : this.mode_infirmier ? (this.mode_detail ? 'inf-detail' : 'inf-consultations') : 'med' },
        titre() { return this.mode_constantes ? 'Prise de constantes' : 'Consultations' },
        filtre_courant() { return this.filtres[this.onglet_actif] || {} },
        affichage_courant() { return this.onglet_charge === this.onglet_actif },
        medecins_filtrables() {
            if (this.mode_infirmier) return this.liste_medecins
            const auth_info = this.$store.getters.authInfo
            return this.liste_medecins.filter(medecin => !auth_info || Number(medecin.id) !== Number(auth_info.id))
        },
        champs() {
            const champs = [{ key: 'patient', label: 'Patient' }, { key: 'sexe_age', label: 'Sexe / âge' }]
            if (this.mode_infirmier || this.onglet_actif === 'all') champs.push({ key: 'medecin', label: 'Médecin' }, { key: 'type_consultation', label: 'Spécialité' })
            if (this.mode_constantes) return champs.concat([{ key: 'date_arrivee', label: 'Arrivée' }, { key: 'actions', label: 'Actions', thClass: 'med-actions-cell', tdClass: 'med-actions-cell' }])
            champs.push({ key: 'date_arrivee', label: 'Arrivée' })
            if (this.onglet_actif === 'waiting') champs.push({ key: 'duree_attente', label: 'Durée d’attente' })
            if (this.mode_detail || this.onglet_actif === 'ongoing') champs.push({ key: 'date_debut', label: 'Début' })
            if (this.onglet_actif === 'closed') champs.push(
                { key: 'date_fin', label: 'Clôture' }, { key: 'issue_consultation', label: 'Issue' },
                { key: 'evolution_clinique', label: 'Évolution clinique' }
            )
            return champs.concat([
                { key: 'etat', label: 'État' },
                { key: 'validite', label: 'Validité' }, { key: 'actions', label: 'Actions', thClass: 'med-actions-cell', tdClass: 'med-actions-cell' }
            ])
        },
        // Onglet Rendez-vous (infirmier) : liste confiée au composant RendezVousMedecin, badge chargé ici
        avec_rendez_vous() { return this.mode_infirmier && !this.mode_constantes && !this.mode_detail }
    },
    mounted() {
        this.charger_medecins()
        this.charger_liste()
        if (this.avec_rendez_vous) this.charger_compteur_rdv()
        if (typeof window !== 'undefined') {
            window.addEventListener('focus', this.actualiser)
            window.addEventListener('clinicaa:consultation-updated', this.actualiser)
        }
        this.refresh_timer = setInterval(() => {
            this.maintenant = Date.now()
            if (!document.hidden && this.requetes_en_cours === 0 && !this.recherche_timer) this.actualiser()
        }, 60000)
    },
    activated() { this.actualiser() },
    beforeDestroy() {
        this.est_detruit = true
        this.sequence++
        this.rdv_sequence++
        clearInterval(this.refresh_timer)
        clearTimeout(this.recherche_timer)
        this.refresh_timer = null
        this.recherche_timer = null
        if (typeof window !== 'undefined') {
            window.removeEventListener('focus', this.actualiser)
            window.removeEventListener('clinicaa:consultation-updated', this.actualiser)
        }
    },
    methods: {
        nombre_onglet(scope) {
            if (scope === 'appointments') return this.rdv_actifs === null ? '—' : this.rdv_actifs
            const value = this.compteurs && this.compteurs[scope]
            return value !== null && value !== undefined && value !== '' && typeof value !== 'boolean' && Number.isInteger(Number(value)) && Number(value) >= 0 ? Number(value) : '—'
        },
        actualiser(event) {
            if (this.avec_rendez_vous) this.charger_compteur_rdv()
            if (this.onglet_actif === 'appointments') return   // le composant des rendez-vous s'actualise lui-même
            if (this.recherche_timer) return
            if (this.requetes_en_cours && !(event && event.type === 'clinicaa:consultation-updated')) return
            return this.charger_liste(false, true)
        },
        libelle_issue: issueLabel,
        libelle_evolution: evolutionLabel,
        async charger_medecins() {
            if (this.mode_infirmier || this.mode_sage_femme) return
            try {
                const response = await store_config.getRolePersonnels()
                if (this.est_detruit) return
                const utilisateurs = Array.isArray(response) ? response : response.data
                this.liste_medecins = (utilisateurs || [])
                    .filter(user => Array.isArray(user.roles) && user.roles.some(role => role.nom === 'ROLE_MEDECIN'))
                    .map(user => ({ id: user.id, name: user.name }))
                this.erreur_medecins = false
            } catch (error) {
                if (!this.est_detruit) this.erreur_medecins = true
            }
        },
        async charger_liste(page_corrigee = false, discret = false) {
            if (this.est_detruit || this.onglet_actif === 'appointments') return
            const sequence = ++this.sequence
            const scope = this.onglet_actif
            const filtre = Object.assign({}, this.filtre_courant)
            this.is_loading = true
            this.rafraichissement_discret = discret && this.affichage_courant
            this.is_error = false
            this.erreur_service = ''
            this.erreur_acces_sf = ''
            this.requetes_en_cours++
            try {
                // Capability remains local: never Vuex, localStorage or component data.
                const credential = await (this.mode_infirmier ? (this.tableau_api || store_consultation).getTableauInfirmierAccess() : (this.tableau_api || store_consultation).getTableauMedecinAccess())
                if (this.est_detruit || sequence !== this.sequence) return
                if (!credential.success || !credential.data || !credential.data.access_token) throw new Error('Accès médecin indisponible')
                const access_token = credential.data.access_token
                const payload = { scope, search_item: filtre.recherche, type_consultation_id: filtre.type_id, doctor_id: this.mode_infirmier || scope === 'all' ? filtre.medecin_id : '', page: filtre.page, access_token }
                if (scope === 'closed') {
                    payload.issue_consultation = filtre.issue_consultation
                    payload.evolution_clinique = filtre.evolution_clinique
                    if (this.period) { payload.period = this.period; payload.month = this.month }
                }
                if (scope === 'started_month' && this.month) payload.month = this.month
                const responses = await Promise.all([
                    this.mode_infirmier ? (this.tableau_api || store_consultation).getTableauInfirmier(payload) : (this.tableau_api || store_consultation).getTableauMedecin(payload),
                    this.mode_infirmier ? (this.tableau_api || store_consultation).getFiltresTableauInfirmier({ scope, access_token }) : (this.tableau_api || store_consultation).getFiltresTableauMedecin({ scope, access_token })
                ])
                if (this.est_detruit || sequence !== this.sequence) return
                const response = responses[0]
                if (!Array.isArray(response.data)) throw new Error('Réponse inattendue')
                const derniere_page = Math.max(1, Number(response.last_page))
                if (!page_corrigee && filtre.page > derniere_page) {
                    this.filtre_courant.page = derniere_page
                    return this.charger_liste(true, discret)
                }
                const ouverts = this.affichage_courant ? this.liste_consultations.filter(item => item._showDetails).map(item => item.consultation_id) : []
                const lignes = response.data.map(item => Object.assign({}, item, { _showDetails: ouverts.includes(item.consultation_id) }))
                if (JSON.stringify(lignes) !== JSON.stringify(this.liste_consultations)) this.liste_consultations = lignes
                this.liste_types = responses[1].type_consultations || []
                if (this.mode_infirmier) {
                    const annuaire = credential.data.medecins || []
                    this.liste_medecins = (responses[1].medecins || []).filter(user => Number(user.id) > 0).map(user => {
                        const identite = annuaire.find(personne => Number(personne.id) === Number(user.id))
                        return { id: user.id, name: identite && identite.nom || user.nom || 'Médecin n° ' + user.id }
                    })
                }
                this.total = Number(response.total)
                this.page_courante = Number(response.current_page)
                this.total_pages = derniere_page
                this.compteurs = response.counts || null
                this.fuseau_horaire = fuseauComplement(response.timezone)
                this.onglet_charge = scope
                this.maintenant = Date.now()
            } catch (error) {
                if (!this.est_detruit && sequence === this.sequence) {
                    this.is_error = true
                    this.erreur_service = error && error.response && error.response.data && error.response.data.message ||
                        error.message || ''
                    this.compteurs = null
                    if (this.mode_sage_femme) {
                        this.liste_consultations = []
                        this.total = 0
                        this.liste_types = []
                        this.onglet_charge = ''
                        const status = error && error.response && error.response.status
                        if (status === 401 || status === 403) this.erreur_acces_sf = 'Accès sage-femme refusé ou expiré. Vérifiez votre rôle actif puis réessayez.'
                    }
                }
            } finally {
                this.requetes_en_cours--
                if (!this.est_detruit && sequence === this.sequence) this.is_loading = false
            }
        },
        changer_onglet(scope) {
            if (!this.onglets.some(onglet => onglet.id === scope) || scope === this.onglet_actif) return Promise.resolve()
            clearTimeout(this.recherche_timer)
            this.recherche_timer = null
            this.onglet_actif = scope
            this.liste_types = []
            if (scope === 'appointments') {
                // Le composant RendezVousMedecin se charge à son affichage ; la liste des consultations en cours est abandonnée
                this.sequence++
                this.is_loading = false
                this.is_error = false
                return Promise.resolve()
            }
            return this.charger_liste()
        },
        naviguer_onglet(event, index) {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
            event.preventDefault()
            const nombre = this.onglets.length
            const cible = event.key === 'Home' ? 0 : event.key === 'End' ? nombre - 1 : (index + (event.key === 'ArrowRight' ? 1 : nombre - 1)) % nombre
            this.changer_onglet(this.onglets[cible].id)
            this.$nextTick(() => this.$refs.onglet[cible].focus())
        },
        rechercher() {
            clearTimeout(this.recherche_timer)
            this.sequence++
            this.recherche_timer = setTimeout(() => {
                this.recherche_timer = null
                this.appliquer_filtres()
            }, 300)
        },
        appliquer_filtres() {
            clearTimeout(this.recherche_timer)
            this.recherche_timer = null
            this.filtre_courant.page = 1
            return this.charger_liste()
        },
        changer_page(page) {
            if (this.is_loading || page < 1 || page > this.total_pages || page === this.page_courante) return
            this.filtre_courant.page = page
            return this.charger_liste()
        },
        date_locale(value) {
            return calendar.instant(value)
        },
        format_date(value, complete) {
            const date = calendar.parts(value, this.fuseau_horaire)
            if (!date) return '—'
            return date.day + '/' + date.month + (complete ? '/' + date.year : '') + ' ' + date.hour + ':' + date.minute
        },
        duree_attente(item) {
            const arrivee = this.date_locale(item.date_arrivee)
            if (!arrivee) return '—'
            // An unstarted, expired bon is administratively closed at its expiry instant.
            const fin = this.date_locale(item.date_debut) || (this.est_bon_expire(item) ? this.date_locale(item.date_expiration_bon) : null)
            const secondes = Math.max(0, Math.floor(((fin ? fin.getTime() : this.maintenant) - arrivee.getTime()) / 1000))
            return calendar.duration(secondes)
        },
        est_bon_expire(item) {
            if (Number(item.is_start) === 1 || Number(item.is_end) === 1) return false
            const expiration = this.date_locale(item.date_expiration_bon)
            return Number(item.bon_expire) === 1 || !!(expiration && expiration.getTime() <= this.maintenant)
        },
        validite_bon(item) {
            const expiration = this.date_locale(item.date_expiration_bon)
            if (!expiration) return { libelle: 'Non renseignée', couleur: 'muted', expire: true }
            const difference = expiration.getTime() - this.maintenant
            if (difference <= 0) return { libelle: 'Expiré', couleur: 'danger', expire: true }
            const jours = Math.ceil(difference / 86400000)
            const aujourdhui = calendar.day(expiration, this.fuseau_horaire) === calendar.day(this.maintenant, this.fuseau_horaire)
            return { libelle: aujourdhui ? 'Aujourd’hui' : jours + ' j restant' + (jours > 1 ? 's' : ''), couleur: jours <= 2 ? 'danger' : jours <= 7 ? 'warning' : jours <= 14 ? 'pale-success' : 'success', expire: false }
        },
        libelle_etat(item) {
            if (Number(item.is_end) === 1) return 'Clôturée'
            if (Number(item.is_start) === 1) return 'En consultation'
            if (this.est_bon_expire(item)) return 'Bon expiré'
            return Number(item.constante) === 1 ? 'Constantes prises' : 'Attente constantes'
        },
        couleur_etat(item) {
            if (Number(item.is_end) === 1) return 'muted'
            if (Number(item.is_start) === 1) return 'primary'
            if (this.est_bon_expire(item)) return 'danger'
            return Number(item.constante) === 1 ? 'success' : 'warning'
        },
        nom_medecin(id) {
            if (!Number(id)) return 'Non attribué'
            const medecin = this.liste_medecins.find(user => Number(user.id) === Number(id))
            return medecin ? medecin.name : 'Médecin n° ' + id
        },
        medecin_effectif(item) {
            return Number(item.medecin_id) > 0 && (Number(item.is_start) === 1 || Number(item.is_end) === 1) ? item.medecin_nom || this.nom_medecin(item.medecin_id) : this.nom_medecin(item.doctor_id)
        },
        complement_possible(item) {
            return !this.mode_infirmier && !this.mode_constantes && Number(item.is_end) === 1 &&
                !!item.complement && item.complement.possible === true && !!item.complement.jusqu_au
        },
        echeance_complement(item) {
            return this.complement_possible(item) ? 'jusqu’au ' + dateComplement(item.complement.jusqu_au, this.fuseau_horaire) : ''
        },
        est_dossier(item) {
            if (this.complement_possible(item)) return false
            return Number(item.is_end) === 1 || this.est_bon_expire(item) ||
                (!this.mode_infirmier && (this.onglet_actif === 'closed' || (this.onglet_actif === 'all' && !this.intervention_possible(item))))
        },
        // Consultation démarrée par un confrère : un médecin ayant la même accessibilité peut la continuer.
        intervention_possible(item) {
            return Number(item.is_start) === 1 && Number(item.is_end) === 0 && Number(item.medecin_id) > 0
        },
        ouvrir_feuille(item) { this.feuille_consultation_id = Number(item.consultation_id); this.feuille_visible = true },
        libelle_action(item) {
            if (this.complement_possible(item)) return 'Compléter'
            if (this.mode_constantes) return Number(item.is_end) === 1 ? 'Voir les constantes' : Number(item.constante) === 1 ? 'Reprendre les constantes' : 'Prendre les constantes'
            if (this.mode_infirmier) return this.est_dossier(item) ? 'Ouvrir dossier' : 'Constantes et soins'
            return this.est_dossier(item) ? 'Ouvrir le dossier' : Number(item.reference_a_prendre_en_charge) === 1 || item.reference_a_prendre_en_charge === true ? 'Prendre en charge' : Number(item.is_start) === 1 ? 'Continuer' : 'Démarrer la consultation'
        },
        motif_action(item) {
            if (this.mode_infirmier) return '' // Read eligibility is enforced by the dedicated server endpoint.
            if (!(item.acces_type === true || Number(item.acces_type) === 1)) return 'Accès à cette spécialité non accordé'
            if (!this.est_dossier(item) && !this.complement_possible(item) && this.validite_bon(item).expire) {
                return item.date_expiration_bon ? 'Bon expiré, repasser en caisse' : 'Validité du bon non renseignée'
            }
            return ''
        },
        async aller_consultation(item) {
            if (this.motif_action(item)) return
            if (this.mode_constantes) { this.$emit('constantes', item); return }
            const dossier = this.est_dossier(item)
            if (!this.mode_infirmier && !dossier && !this.complement_possible(item) && Number(item.is_start) !== 1) {
                if (!this.mode_sage_femme && (Number(item.reference_a_prendre_en_charge) === 1 || item.reference_a_prendre_en_charge === true)) {
                    if (this.prise_reference_en_cours) return
                    this.prise_reference_en_cours = Number(item.consultation_id)
                    this.erreur_reference = ''
                    try {
                        const access = await (this.tableau_api || store_consultation).getTableauMedecinAccess()
                        if (!access || access.success !== true || !access.data || !access.data.access_token) throw new Error('Autorisation indisponible.')
                        const result = await (this.tableau_api || store_consultation).prendreReferenceTableauMedecin(item.consultation_id, access.data.access_token)
                        if (this.est_detruit) return
                        if (!result || result.success !== true || Number(result.consultation_id) !== Number(item.consultation_id)) throw new Error('La prise en charge n’a pas été confirmée.')
                        item.reference_a_prendre_en_charge = false
                        item.doctor_id = result.doctor_id
                    } catch (error) {
                        if (!this.est_detruit) this.erreur_reference = error && error.response && error.response.data && error.response.data.message ||
                            (error && error.message) || 'La prise en charge a échoué.'
                        return
                    } finally {
                        this.prise_reference_en_cours = null
                    }
                }
                const selection = this.mode_sage_femme ? Object.assign({}, item, { source_tableau_sage_femme: true }) : item
                return this.$refs.demarrage.ouvrir_demarrage_tableau(selection)
            }
            return this.naviguer_consultation(item, dossier)
        },
        consultation_demarree(item) {
            return this.naviguer_consultation(item, false, true)
        },
        naviguer_consultation(item, dossier, initiale = false) {
            this.$store.commit('SET_SELECTED_CONSULTATION_ENCOURS', dossier ? {} : {
                consultation_id: item.consultation_id,
                patient_id: item.patient_id,
                tarif_consultation_id: item.tarif_consultation_id,
                is_mobile_user: item.patient_has_mobile_user,
                ...(this.mode_sage_femme ? { source_tableau_sage_femme: true } : {}),
                source_tableau_medecin: !this.mode_infirmier && !this.mode_sage_femme,
                source_tableau_infirmier: this.mode_infirmier
            })
            const query = dossier ? {} : { [this.mode_sage_femme ? 'sf001' : this.mode_infirmier ? 'inf001' : 'med004']: String(item.consultation_id), tarif: String(item.tarif_consultation_id) }
            if (initiale) query.initiale = '1'
            return this.$router.push({
                path: '/patients/' + item.patient_id + (dossier ? '/historique' : '/consulter'),
                query
            })
        },
        // Badge de l'onglet Rendez-vous (infirmier) : rendez-vous planifiés aujourd'hui, tous les médecins (C8 : période « jour »)
        async charger_compteur_rdv() {
            if (this.est_detruit || !this.avec_rendez_vous) return
            const sequence = ++this.rdv_sequence
            try {
                const credential = await (this.tableau_api || store_consultation).getTableauInfirmierAccess()
                if (this.est_detruit || sequence !== this.rdv_sequence) return
                if (!credential || !credential.success || !credential.data || !credential.data.access_token) throw new Error('Accès indisponible')
                const response = await (this.tableau_api || store_consultation).getRendezVousInfirmier({ periode: 'jour', page: 1, per_page: 1, access_token: credential.data.access_token })
                if (this.est_detruit || sequence !== this.rdv_sequence) return
                const actifs = response && response.counts ? Number(response.counts.actifs) : NaN
                this.rdv_actifs = Number.isInteger(actifs) && actifs >= 0 ? actifs : null
            } catch (error) {
                if (!this.est_detruit && sequence === this.rdv_sequence) this.rdv_actifs = null
            }
        },
        // Bouton Actualiser de la carte quand l'onglet Rendez-vous est affiché
        actualiser_rendez_vous() {
            this.charger_compteur_rdv()
            const composant = this.$refs.rendez_vous
            return composant && typeof composant.recharger === 'function' ? composant.recharger() : Promise.resolve()
        },
        details_patient(item) {
            return [
                ['Patient', item.patient_nom], ['N° dossier', item.dossier], ['Téléphone', item.telephone], ['Assurance', item.assurance],
                [this.mode_sage_femme ? 'Praticien attribué' : 'Médecin attribué', this.mode_sage_femme ? (this.$store.getters.authInfo || {}).name : this.nom_medecin(item.doctor_id)], ['Médecin en consultation', item.medecin_nom],
                ['Spécialité', item.type_consultation], ['Moment', item.moment], ['Arrivée', this.format_date(item.date_arrivee, true)],
                ['État', this.libelle_etat(item)], ['Bon', item.reference_bon], ['Expiration', this.format_date(item.date_expiration_bon, true)],
                ['Début', this.format_date(item.date_debut, true)], ['Clôture', this.format_date(item.date_fin, true)],
                ['Issue', this.libelle_issue(item.issue_consultation)], ['Évolution clinique', this.libelle_evolution(item.evolution_clinique)],
                ['Destination / orientation', item.orientation_destination], ['Précisions', item.issue_commentaire]
            ]
        }
    }
}
